import { Component, Input, OnInit, ViewChild } from '@angular/core'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { HoldEventType, holdEventTypes } from '@tv3/constants/hold-event-types'
import { HoldDialogService } from '@tv3/containers/calendar/hold/hold-dialog/hold-dialog.service'
import { CalendarEvent } from '@tv3/store/calendar/calendar.model'

@Component({
  selector: 'app-hold-results-table',
  templateUrl: './hold-results-table.component.html',
  styles: [
    `
      table {
        width: 100%;
      }
    `,
  ],
})
export class HoldResultsTableComponent implements OnInit {
  @Input() results: any[] = []

  @ViewChild('paginator') set paginator(p: MatPaginator) {
    this.dataSource.paginator = p
  }

  dataSource = new MatTableDataSource<any>()
  displayedColumns = ['title', 'rental', 'start', 'end', 'type']

  constructor(private holdDialog: HoldDialogService) {}

  ngOnInit() {
    this.dataSource.data = this.results || []
  }

  getEventType(type: HoldEventType) {
    return holdEventTypes.find((t) => t.id === type)?.name || ''
  }

  onEdit(hold: any) {
    this.holdDialog.open({ hold: CalendarEvent.deserialize(hold) })
  }
}
